"use client";
import { motion } from "framer-motion";
import { Send, Edit3, Rocket, RussianRuble } from "lucide-react";
import { Link } from "react-router-dom"; // ✅ import Link

export default function HowItWorks() {
  const steps = [
    {
      icon: <Send size={32} className="text-indigo-600" />,
      title: "Submit Your Details",
      desc: "Start your path to top opportunities! Submit your resume and professional profiles—LinkedIn, Naukri, Wellfound, and more—safely through our secure form.",
    },

    {
      icon: <Edit3 size={32} className="text-indigo-600" />,
      title: "Expert Optimization",
      desc: "Our team rewrites and structures your profile using recruiter insights and data-driven methods.",
    },
    {
      icon: <Rocket size={32} className="text-indigo-600" />,
      title: "Connect With Experts",
      desc: "Get one-on-one guidance from industry experts who will groom your profile according to your target job role and connect you directly with top recruiters.",
    },
    {
      icon: <RussianRuble size={32} className="text-indigo-600" />,
      title: "Mock Interviews With Experts",
      desc: "Practice real interview scenarios and receive actionable feedback to improve instantly.",
    },
  ];

  return (
    <section id="how" className="py-24 bg-gray-900 text-white relative">
      <div className="absolute inset-0 bg-gradient-to-b from-indigo-900 to-gray-900 opacity-80" />

      <div className="relative z-10 max-w-6xl mx-auto px-6 text-center">
        {/* Heading */}
        <motion.h2
          className="text-4xl font-bold mb-16 bg-gradient-to-r from-indigo-300 to-purple-300 text-transparent bg-clip-text"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          How It Works
        </motion.h2>

        {/* Steps Grid */}
        <div className="grid md:grid-cols-4 sm:grid-cols-2 gap-10">
          {steps.map((step, i) => (
            <motion.div
              key={i}
              className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 shadow-lg border border-white/10 hover:border-indigo-400/40 hover:shadow-indigo-400/20 transition"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.2, duration: 0.6 }}
              viewport={{ once: true }}
            >
              <div className="flex justify-center mb-4">{step.icon}</div>
              <h3 className="text-xl font-semibold mb-2">{step.title}</h3>
              <p className="text-gray-300 leading-relaxed">{step.desc}</p>
            </motion.div>
          ))}
        </div>

        {/* See More Button using Link */}
        <Link
          to="/aboutUs"
          className="inline-block mt-14 px-8 py-3 rounded-xl bg-gradient-to-r from-indigo-600 to-purple-600 
            text-white font-semibold shadow-lg hover:shadow-purple-400/40 transition-all"
        >
          See More in Details →
        </Link>
      </div>
    </section>
  );
}
